<template>
<div class="operate_left blue">
  <door-box :height="812" width="100%">
     <div class="box_wrap">
       <div class="top">
         <equipmentRate></equipmentRate>
       </div>
       <div class="bottom">
         <intelligentMonitoring></intelligentMonitoring>
       </div>
     </div>
  </door-box>
</div>
</template>

<script>
import doorBox from '../components/doorBox';
import equipmentRate from './component/equipmentRate';
import intelligentMonitoring from './component/intelligentMonitoring';
export default {
  name: 'index',
  components: { doorBox,equipmentRate,intelligentMonitoring },
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
.operate_left {
  // border: 1px solid green;
  height: 100%;
  @include bg-box(100%, 100%, 'leftBig.png');
  .isBaoSteel {
    background: #020F3F;
  }
  .box_wrap {
    height: 100%;
    .top {
      height: 34%;
      margin-bottom: 10px;
      @include bg-box(100%, 34%, "left_top.png");
    }
    .bottom {
      height: 65%;
      @include bg-box(100%, 65%, "left_bottom.png");
      padding: 10px 10px 15px;
      box-sizing: border-box;
    }
  }
}
.blue {
  background: rgba(0, 106, 255, 0.05);
  border: 1px solid rgba(132, 170, 255, 0.5);
}
</style>
